import { createSlice } from "@reduxjs/toolkit";

export const filterSlice = createSlice({
  name: "filters",
  initialState: {
    filterApplied: false,
    range: {
      startDate: null,
      endDate: new Date().toISOString(),
      key: "range",
    },
    startTime: new Date().toISOString(),
    endTime: new Date().toISOString(),
    cameras: [],
    species: [],
    showUntagged: false, // <--- NEW STATE
  },
  reducers: {
    setTimeRange: (state, action) => {
      state.startTime = action.payload.startTime.toISOString();
      state.endTime = action.payload.endTime.toISOString();
    },
    setFilterApplied: (state, action) => {
      state.filterApplied = action.payload;
    },
    setDateRange: (state, action) => {
      state.range = {
        startDate: action.payload.startDate
          ? action.payload.startDate.toISOString()
          : null,
        endDate: action.payload.endDate
          ? action.payload.endDate.toISOString()
          : new Date().toISOString(),
        key: action.payload.key || "range",
      };
    },
    setCameras: (state, action) => {
      let cameraIds = action.payload;
      if (Array.isArray(cameraIds)) {
        const flatIds = [];
        for (let i = 0; i < cameraIds.length; i++) {
          if (Array.isArray(cameraIds[i])) {
            flatIds.push(...cameraIds[i]);
          } else {
            flatIds.push(cameraIds[i]);
          }
        }
        state.cameras = flatIds;
      } else {
        state.cameras = cameraIds;
      }
    },
    setSpecies: (state, action) => {
      state.species = action.payload;
    },
    // <--- NEW REDUCER
    setShowUntagged: (state, action) => {
      state.showUntagged = action.payload;
    },
    resetFilters: (state) => {
      state.filterApplied = false;
      state.range = {
        startDate: null,
        endDate: new Date().toISOString(),
        key: "range",
      };
      state.startTime = new Date().toISOString();
      state.endTime = new Date().toISOString();
      state.cameras = [];
      state.species = [];
      state.showUntagged = false; // Reset this as well
    },
  },
});

// Action creators
export const {
  setDateRange,
  setCameras,
  setSpecies,
  setFilterApplied,
  setTimeRange,
  resetFilters,
  setShowUntagged, // <--- EXPORT NEW ACTION
} = filterSlice.actions;
export const selectFilters = (state) => state.filters;

export default filterSlice.reducer;
